<template>
  <v-btn
    small
    :class="{ hidden: hidden }"
    @click="$emit('click', $event)"
    dark
    color="rgb( 213,0,0)"
  >
    <v-icon>filter_alt</v-icon>
    {{ $t('parents.clear_filter') }}
  </v-btn>
</template>
<script>
export default {
  props: ['hidden'],
}
</script>
<style scoped>
.hidden.v-btn {
  visibility: hidden;
  opacity: 0;
}
.v-btn {
  color: white;
  border-radius: 5px;
  font-size: 12px;
  transition: opacity 0.5;
}
.v-icon {
  margin-right: 5px;
}

/* /deep/ .v-btn__content {
     width: 65px;
} */
</style>
